import TemplatesCategoryCachedService from '@/core/services/cachedData/TemplatesCategoryCachedService'
import { BaseWidgetTemplate } from '@/types/templates'

let widgetTemplateMapCache: Map<number, BaseWidgetTemplate> | undefined
let widgetTemplateListCache: BaseWidgetTemplate[] | undefined

export function getTemplateCategories () {
    return TemplatesCategoryCachedService.data.CategoryList || []
}
export function getWidgetTemplates () {
    return TemplatesCategoryCachedService.data.TemplateList || []
}

function getWidgetTemplateMap (): Map<number, BaseWidgetTemplate> {
    const templates = getWidgetTemplates()

    if (widgetTemplateMapCache && widgetTemplateListCache === templates) {
        return widgetTemplateMapCache
    }

    widgetTemplateListCache = templates
    widgetTemplateMapCache = new Map(templates.map(template => [ template.TemplateID, template ]))

    return widgetTemplateMapCache
}

export function getWidgetTemplate (templateId: number): BaseWidgetTemplate | undefined {
    if (!templateId) {
        return undefined
    }
    return getWidgetTemplateMap().get(templateId)
}
export function getNotEmptyTemplateCategories () {
    const templates = getWidgetTemplates()
    return getTemplateCategories().filter(category => {
        return !!(templates
            .filter(template => template.CategoryList && template.CategoryList.includes(category.CategoryID))
        ).length
    })
}
